import { Location } from "../../../types/location/location";
import { LocationDto } from "../../../types/location/location-dto";

export const convertLocationDtoToLocation = (
  locationDto: LocationDto
): Location => {
  return {
    id: locationDto.id,
    road: locationDto.road,
    jibun: locationDto.jibun,
    longitude: locationDto.longitude,
    latitude: locationDto.latitude,
    images: locationDto.images,
  };
};
